<div>
  <div class="container-fluid">
    <div class="now-error-container">
      <div class="now-error-content">
        <h1 class="h2">Das aufgerufene Angebot ist leider nicht mehr verfügbar.</h1>
        <div class="now-body-large">
          <p class="fw-bold">Mögliche Gründe:</p>
          <div>
            <ul class="now-list">
              <li>Der Starttermin des Angebots ist bereits abgelaufen.</li>
              <li>Das Angebot wurde durch den Anbieter gelöscht.</li>
              <li>Die eingegebene URL ist nicht korrekt.</li>
            </ul>
          </div>
          <p>
            Wir legen großen Wert darauf, das Weiterbildungs&shy;angebot immer auf dem neuesten
            Stand zu halten und bitten um Verständnis.
          </p>
        </div>
        <a
          class="now-btn now-btn-primary now-btn-icon now-icon-arrow-right-after"
          [routerLink]="['']"
          queryParamsHandling="preserve"
        >
          Zur Weiterbildungssuche
        </a>
      </div>
      <img
        title="Angebot ist nicht verfügbar"
        class="img404"
        src="assets/images/angebot-nicht-gefunden.svg"
        alt="Angebot nicht gefunden"
      />
    </div>
  </div>
</div>
